import Placeholder from "@tiptap/extension-placeholder";

/**
 * Read-only manuscript surfaces still need empty-node decorations so shared
 * typography can distinguish legacy spacer paragraphs from real content.
 * No placeholder text is rendered; the class is only a styling hook.
 */
export const createReadOnlyPlaceholder = () =>
  Placeholder.configure({
    placeholder: "",
    showOnlyWhenEditable: false,
    showOnlyCurrent: false,
    emptyNodeClass: "is-editor-empty",
  });
